import { render, staticRenderFns } from "./ReviewTabYourVotes.vue?vue&type=template&id=4a3dac64&"
import script from "./ReviewTabYourVotes.vue?vue&type=script&lang=js&"
export * from "./ReviewTabYourVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports